
import React from 'react';

interface BetaStampProps {
    className?: string;
}

const BetaStamp: React.FC<BetaStampProps> = ({ className = '' }) => {
    return (
        <div className={`
            inline-block border-[3px] border-red-700 text-red-700 
            font-black uppercase tracking-widest text-[0.6rem] sm:text-xs px-1.5 py-0.5 
            rounded-sm transform -rotate-12 opacity-80 mix-blend-multiply 
            pointer-events-none select-none z-10 whitespace-nowrap shadow-sm bg-red-50/20 backdrop-blur-[1px]
            ${className}
        `}>
            Beta
        </div>
    );
};

export default BetaStamp;
